export default {"src":"/_next/static/media/dgd.f0f491e1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};